import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/lib/useApi";
import { Package } from "lucide-react";

export default function ResellerProducts() {
  const api = useApi();
  const { data = [], isLoading } = useQuery({
    queryKey: ["reseller-products"],
    queryFn: async () => (await api.get("/reseller/products")).data,
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Prodotti assegnati</h1>
        <p className="text-sm text-slate-500 mt-1">Catalogo prodotti che Le è stato abilitato a rivendere.</p>
      </div>
      {isLoading && <div className="text-slate-500">Caricamento…</div>}
      {!isLoading && data.length === 0 && (
        <div className="bg-white border border-[#E2DDD5] rounded-xl p-10 text-center text-slate-500">Nessun prodotto assegnato. Il Super Admin provvederà all'assegnazione.</div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.map((p) => (
          <div key={p.id} className="bg-white border border-[#E2DDD5] rounded-xl p-5" data-testid={`r-product-${p.slug}`}>
            <div className="flex items-center gap-2"><Package size={16} className="text-[#B84A2B]" /><div className="font-semibold">{p.name}</div></div>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{p.description}</p>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {p.modules?.map((m) => (
                <span key={m.id} className="text-[11px] px-2 py-0.5 rounded-full bg-[#F2F0EB] border border-[#E2DDD5]">{m.name}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
